var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserNotificationsViewAll"},[_c('a',{staticClass:"link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._v("View All")])])}
var staticRenderFns = []

export { render, staticRenderFns }